import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { IMAGING_CATEGORY_DETAILS_API_URL,
    IMAGING_DATE_FILTER_API_URL,
    IMAGING_EXPOR_LINK_DETAILS_URL,
    IMAGING_EXPORT_DETAILS_REQUEST_URL,
    IMAGING_EXPORT_DETAILS_STATUS_URL,
    IMAGING_NET_CATEGORY_DETAILS_API_URL,
    IMAGING_TOP_FILTER_API_URL,

 } from './apiUrlConstants';

const _httpService = new HttpService();
const cache = new Map();

if(checkIsInternal()){
    _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}
else{
 _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
 //_httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}

export const getDateFilterData= async () =>{    
    const url = IMAGING_DATE_FILTER_API_URL;
    let finalUrl = url;

    try {
        const responseData: any = await _httpService.get(finalUrl);
        return responseData;
    } catch {
        return null;
    }
}

export const getTopFilterData= async (payload:any) =>{    
    const url = IMAGING_TOP_FILTER_API_URL;
    const hasTin = payload?.NetworkLeverTopFilter?.tin;
    let finalUrl = hasTin ? url + "TIN" : url + "HCO";

    try {
        // const responseData = hco1;
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
}


export const getImagingcategoryData= async (payload:any) =>{    
    const url = IMAGING_CATEGORY_DETAILS_API_URL;
    let finalUrl = url;

    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
};

export const getNetImagingcategoryData= async (payload:any) =>{    
    const url = IMAGING_NET_CATEGORY_DETAILS_API_URL;
    let finalUrl = url;

    try {
        // const responseData = breakdown;
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
};

export const getExporDetails= async (payload:any) =>{    
    const url = IMAGING_EXPORT_DETAILS_REQUEST_URL;
    let finalUrl = url;

    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
};

export const getExporDetailsStatus= async (payload:any) =>{    
    const url = IMAGING_EXPORT_DETAILS_STATUS_URL;
    let finalUrl = url;

    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
};

export const getExporDetailsLinks= async (payload:any) =>{    
    const url = IMAGING_EXPOR_LINK_DETAILS_URL;
    let finalUrl = url;

    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
};

export const getImagingCatViewData= async (payload:any) =>{    
    const url = IMAGING_NET_CATEGORY_DETAILS_API_URL;
    let finalUrl = url;

    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
}